import React, { useEffect, Fragment, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import scrollTo from 'gatsby-plugin-smoothscroll'
import PATHS, { LANDING_PAGE_SECTIONS } from 'src/utils/paths'
import withLocation from 'src/hoc/withLocation'
import { isNotNilOrEmpty } from 'src/utils/ramda'
import SwipeableDrawer from './SwipeableDrawer'
import useScrollDetector from 'src/hooks/useScrollDetector'
import LanguagePicker from 'src/features/locales/LanguagePicker'

import LogoDark from 'src/assets/images/vectors/panda-logo-dark.svg'
import { MenuIcon } from 'src/assets/icons/Menu.js'
import X from 'src/assets/images/vectors/x.svg'

import Button from 'src/components/atoms/Button'

const NonAuthNavigationMobile = props => {
  const { t } = useTranslation()
  const [isMenuOpen, setMenuOpen] = useState(false)
  const handleOpen = () => setMenuOpen(true)
  const handleClose = () => setMenuOpen(false)

  const hasScrolled = useScrollDetector(20)
  const {
    location: { pathname, hash },
    navigate
  } = props

  useEffect(() => {
    if (isNotNilOrEmpty(hash)) {
      setTimeout(() => scrollTo(hash), 500)
    }
  }, [hash])

  const scrollToSection = id => () => {
    handleClose()
    navigate(`/#${id}`)
  }

  const navigateToPath = path => () => navigate(path)
    
  const isHomepage = pathname === PATHS.homepage
  const [primaryState, setPrimaryState] = useState(isHomepage && !hasScrolled)
  useEffect(() => {
    setPrimaryState(isHomepage && !hasScrolled)
  }, [hasScrolled])

  return (
    <Fragment>
      <StyledTopNav primaryState={primaryState}>
        <StyledNavSection>
          <img className='top-nav-logo__image' src={LogoDark} alt='logo' />
        </StyledNavSection>
        <StyledNavSection>
          <div className='top-nav-logo__menu-icon'>
            <MenuIcon onClick={handleOpen} />
          </div>
        </StyledNavSection>
      </StyledTopNav>
        <SwipeableDrawer
          open={isMenuOpen}
          handleClose={handleClose}>
            <MobileDrawerContainer>
              <MobileDrawerLogo>
                <img className='mobile-drawer__logo-image' src={LogoDark} alt='app-logo' />
                <img tabIndex={0} onClick={handleClose} className='mobile-drawer__close-button' src={X} alt='close-button' role='button' />
              </MobileDrawerLogo>
              <MobileDrawerContent>
                <a href={`/#${LANDING_PAGE_SECTIONS.howItWorksSection}`} onClick={scrollToSection(LANDING_PAGE_SECTIONS.howItWorksSection)}>
                  {t('navigation.whoIsPanda')}
                </a>
                <a href={`/#${LANDING_PAGE_SECTIONS.history}`} onClick={scrollToSection(LANDING_PAGE_SECTIONS.history)}>
                  {t('navigation.history')}
                </a>
                <a href={`/#${LANDING_PAGE_SECTIONS.faq}`} onClick={scrollToSection(LANDING_PAGE_SECTIONS.faq)}>
                  {t('navigation.faq')}
                </a>
                <a href={`/#${LANDING_PAGE_SECTIONS.contactSection}`} onClick={scrollToSection(LANDING_PAGE_SECTIONS.contactSection)}>
                  {t('navigation.contact')}
                </a>
                <Button onClick={navigateToPath(PATHS.logIn)} size='normal' color='secondary'>{t('navigation.login')}</Button>
                <div className='bottom'>
                  <LanguagePicker resetState={isMenuOpen} forceTopOffset='-83' />
                </div>
              </MobileDrawerContent>
            </MobileDrawerContainer>
        </SwipeableDrawer>
    </Fragment>
  )
}

const StyledTopNav = styled.div`
  height: 72px;
  width: 100%;
  position: fixed;
  background-color: ${props => props.primaryState ? 'transparent' : props.theme.palette.common.white};
  top: 0;
  display: flex;
  z-index: 100;
`

const StyledNavSection = styled.div`
  width: 50%;
  display: flex;

  .top-nav-logo__image {
    width: 155px;
    height: 32px;
    margin-left: 16px;
    margin-right: auto;
    margin-top: auto;
    margin-bottom: auto;
  }

  .top-nav-logo__menu-icon {
    width: 16px;
    height: 16px;
    margin-left: auto;
    margin-right: 16px;
    margin-top: auto;
    margin-bottom: auto;
    font-size: 16px;
  }
`

const MobileDrawerContainer = styled.div`
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
`

const MobileDrawerLogo = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 20px;
  justify-content: space-between;
  
  .mobile-drawer__logo-image {
    margin-right: 5px;
    height: 33px;
  }

  .mobile-drawer__close-button {
    padding-right: 16px;
    height: 17px;
  }
`

const MobileDrawerContent = styled.div`
  display: flex;
  flex-grow: 2;
  flex-direction: column;
  position: relative;

    a {
      margin-top: 32px;
      font-size: 14px;
      font-weight: 500;
      white-space: nowrap;
      cursor: pointer;

      &:nth-child(1) {
        margin-top: 16px;
      }
    }

    button {
      margin-top: 32px;
      width: 118px;
      text-transform: uppercase;
      font-size: 14px;
    }

    .bottom {
      position: absolute;
      bottom: 0;
    }
`

export default withLocation(NonAuthNavigationMobile)
